<template>
    <div>
        <div class="vertical-center text-left mb-4">
			<span v-if="filter.from_date"
                  class="call-log-head">
				Status Per User from
                <strong>{{ filter.from_date | fixFullDateLocal }}</strong>
                to
                <strong>{{ filter.to_date | fixFullDateLocal }}</strong>
			</span>
            <span v-if="!filter.from_date"
                  class="call-log-head">
				User Call Status
                <strong>All Time</strong>
			</span>
        </div>
        <div class="placeholder text-center d-flex align-items-center justify-content-center"
             :class="{ blink: loading }"
             v-if="loading || campaigns.length == 0"
             style="height: 450px">
            <i class="material-icons loader text-greenish text-4x">
                &#xE863;
            </i>
        </div>
        <div style="height: 450px"
             v-else>
            <graph-data-switch :series="options.series"
                               :type="type">
                <highcharts v-bind:id="graph_id"
                            v-show="is_done && options.series?.length > 0"
                            :options="options"
                            style="height: 450px"
                            ref="highchart">
                </highcharts>
                <div class="el-table__empty-block"
                     v-show="is_done && !options.series?.length">
                    <span class="el-table__empty-text"
                          style="color: #606266;">
                        No Data
                    </span>
                </div>
            </graph-data-switch>
        </div>
    </div>
</template>

<script>
    import auth from '../auth'
    import {graph_mixin, report_mixin} from '../mixins'

    export default {
        props: ['type'],

        mixins: [report_mixin, graph_mixin],

        data() {
            return {
                auth: auth,
                loading: false,
                aggregated_counts: [],
                axisLabels: [],
                graph_id: 'reports-user-status-inverse-graph',
                report_type: 'status_v_user',
                options: {
                    chart: {
                        type: 'bar',
                    },
                    plotOptions: {
                        column: {
                            // cursor: 'pointer',
                            stacking: 'normal',
                            crisp: false,
                            dataLabels: {
                                enabled: true,
                                formatter: function () {
                                    if (this.y != 0) {
                                        return this.y
                                    }
                                },
                                crop: false,
                                style: {
                                    fontSize: '14px'
                                }
                            }
                        },
                    },
                    xAxis: {
                        type: "category",
                    },
                    yAxis: {
                        minTickInterval: 1,
                        title: {
                            text: 'Number Of Calls & Texts',
                            style: {
                                'font-size': '14px',
                                'color': '#090A0D'
                            }
                        },
                        min: 1,
                        startOnTick: false
                    },
                    tooltip: {
                        headerFormat: "",
                        pointFormatter: function () {
                            let toReturn = 'The status ' + '<b>' + this.series.name + '</b> of user <b>' + this.name + '</b><br>'
                            toReturn += 'has ' + '<b>' + this.y.toLocaleString() + '</b> Calls & Texts<br>'

                            return toReturn
                        },
                        split: false,
                        enabled: true,
                    },
                }
            }
        },

        methods: {
            generateGraphData: function () {
                // setup the data attrs
                let data_series = []

                let xAxisLabels = []
                let seriesLabels = []
                let seriesNames = []

                //set status colors
                let status_colors = []
                status_colors['completed'] = '#4caf50'
                status_colors['in-progress'] = '#3f51b5'
                status_colors['abandoned'] = '#9c27b0'
                status_colors['missed'] = '#f44336'
                status_colors['others'] = '#F2AF29'

                //get distinct chart series values
                let keys = Object.keys(this.aggregated_counts)
                for (let index in keys) {
                    let campaign_data = this.aggregated_counts[keys[index]]

                    //do not include empty data
                    if (Object.keys(campaign_data.data).length > 0) {
                        for (let key in campaign_data.data) {
                            if (seriesNames.indexOf(campaign_data.data[key].name) < 0) {
                                seriesLabels.push({
                                    name: campaign_data.data[key].name,
                                    color: (status_colors[key]) ? status_colors[key] : status_colors['others'],
                                })
                                seriesNames.push(campaign_data.data[key].name)
                            }
                        }
                    }
                }

                //loop on chart series and assign its respective datapoints
                seriesLabels.forEach(axisLabel => {
                    let campaigns = []

                    let keys = Object.keys(this.aggregated_counts)
                    for (let index in keys) {
                        let campaign_data = this.aggregated_counts[keys[index]]

                        //do not include empty data
                        if (Object.keys(campaign_data.data).length > 0) {
                            let labelValue = '',
                                yVal = 0

                            //assign yaxis value to its respective xaxis point
                            for (let key in campaign_data.data) {
                                if (campaign_data.data[key].name == axisLabel.name) {
                                    labelValue = campaign_data.user_name
                                    yVal = parseFloat(campaign_data.data[key].count)

                                    break
                                }
                            }
                            if (labelValue !== '') {
                                campaigns.push({
                                    name: labelValue,
                                    y: yVal,
                                })
                            }

                            //store xaxis labels. we can use this to update chart's xaxis labels
                            if (xAxisLabels.indexOf(campaign_data.name) < 0) {
                                xAxisLabels.push(campaign_data.name)
                            }
                        }
                    }

                    //assign statuses to chart series
                    data_series.push({
                        name: (typeof axisLabel === 'string' ? axisLabel.capitalize() : axisLabel.name.capitalize()),
                        color: axisLabel.color,
                        data: campaigns,
                    })
                })

                this.axisLabels = xAxisLabels

                //no data flag
                if (data_series.length) {
                    this.options.series = data_series
                } else {
                    this.options.series = []
                }
            }
        }
    }
</script>
